import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Kích hoạt plugin
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Chuyển đổi thời gian từ chuỗi yyyyMMddHHmmss sang giờ địa phương
 * @param {string} rawDateStr - Ví dụ: "20250723181027"
 * @returns {string} - Thời gian đã format theo giờ địa phương, ví dụ: "24/07/2025 01:10:27"
 */
function formatPaymentDate(rawDateStr) {
  return dayjs(rawDateStr, "YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm:ss");
}

export default formatPaymentDate;
